<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">{{title}}</h4>
      </div>

      <div class="cell shrink">
        <router-link :to="{ name: 'InstillingerList' }" class="button primary transparent" >Gå tilbake</router-link>
      </div>
    </div>

    <div class="content-container flex-row">
      <div class="sidebar left fixed subnav show-for-large">
        <div class="fixed-container">
          <ul>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'Label'}">Kunst / Nett</router-link>
            </li>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'LabelWine'}">Vin</router-link>
            </li>
          </ul>
        </div>
      </div>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstillingerLabel',
  data () {
    return {
      submitStatus: null
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Label'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/Label/Label.vue